import { gql } from "@apollo/client";export default gql`query userAggregate($where: user_bool_exp) {
  userAggregate: user_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`;
